import indexer from "../types/genericTypes";
import { config } from "../../config/domain";

export const logoDimensions = {
  desktop: {
    width: "125",
    height: "30",
    viewbox: "0 0 125 30",
  },
  mobile: {
    width: "111",
    height: "20",
    viewbox: "5 5 115 17",
  },
};

export enum ELoginScreenState {
  LOADING = 1,
  LOGIN_ID,
  PASSWORD,
  YOB,
  CONSENTS,
  RESET_CREDS,
  CLEVERTAP,
  MERGE,
  RM_RATING,
  ACC_OPENING,
  LEAD_FORM,
  VENDOR_CNST,
}

export enum ELoginPopupState {
  RESET_SUCC = 1,
  LOGINID_SENT,
  INACTIVE_ACC,
  EMAIL_SENT,
  RM_RATING_SUCC,
  OPEN_ACC_SUCC,
  MERGE_REQUESTED,
  REQUESTED,
  NOT_ENABLED,
  ONE_ACCOUNT,
  LOGIN_FAILED,
  INCOME_DECL_CNST,
  INVALID_PAN_CNST,
  INVALID_NAME_CNST,
  INVALID_EMAIL_MOBILE_CNST,
  INVALID_EMAIL_CNST,
  INVALID_MOBILE_CNST,
  Account_React_CNST,
  INVALID_ADDRESS_CNST,
  INVALID_NOMIN_CNST,

}

export const consentKeyMap: indexer = {
  eqstwt: "Eq. STWT",
  bseMfstwt: "MF STWT",
  costwt: "Co. STWT",
  mtf: "MTF",
  wtsap: "Whatsapp",
};

// used to show the progress in submit button of change password form
export enum EResetSubmitState {
  ver_login_id = "ver_login_id",
  ver_password = "ver_password",
}

export const urls = {
  home: "/clientarea/service-request",
  cipPassThroughBase: "",
  report: config.rootUrl + "reports",
  login: "/login",
};
